export const DESCRIPTION_HTML_ALLOWED_TAGS = ['p', 'br', 'b', 'ul', 'li'];
//# sourceMappingURL=description-html-allowed-tags.js.map